import { configureStore, combineReducers } from "@reduxjs/toolkit";
import processReducer from "./rootReducer";
import userReducer from "./UserSlice";
import warehouseReducer from "./warehouseSlice";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  process: processReducer,
  user: userReducer,
  warehouse: warehouseReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);
export default store;
